import React, { useEffect, useState } from "react";
import { Layout, Menu, ConfigProvider, Button } from "antd";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  LoadingOutlined,
  LogoutOutlined,
  MenuOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import Pishkhan from "../icons/pishkhan.svg";
import farmers from "../icons/farmer.svg";
import myReview from "../icons/myreview.svg";
import myPlans from "../icons/mayPlans.svg";
import personalPage from "../icons/profileManger.svg";
import edit from "../../icons/Edit_Pencil_Line_01.svg";
import shop from "../../icons/shop.svg";
import calender from "../../icons/Calendar_Week.svg";
import expertLogo from "../../icons/agroiranexpert-logo.svg";
import Counter from "./counter";
import MyReviews from "./MyReviews";
import MyPlans from "./MyPlans";
import PersonalPage from "../../features/personalPage";
import Content from "../../features/contentPage";
import MyFarmers from "../../features/MyFarmers/MyFarmers";
import AllPlans from "../../features/MyFarmers/components/selectedFarmer/allPlans";
import SelectedFarmer from "../../features/MyFarmers/components/selectedFarmer";
import AllVisit from "../../features/MyFarmers/components/selectedFarmer/allVisit";
import { getExpertProfile, logout } from "../../service/api";
import { useMutation } from "@tanstack/react-query";
import Shop from "../../features/shop/Shop";
import { useQuery } from "@tanstack/react-query";
import Comments from "../comments";
import Article from "../../features/contentPage/components/expertArticles/Article";

function DashboardLayout() {
  const [logoutLogo, setLogoutLogo] = useState(<LogoutOutlined />);
  const [expertProfile, setExpertProfile] = useState();
  let w = document.documentElement.clientWidth || window.innerWidth;
  const [miniLogout, setMiniLogout] = useState(false);
  const Logout = () => {
    if ((w <= 1024) & (miniLogout === false)) {
      setMiniLogout(true);
    } else if ((w <= 1024) & (miniLogout === true)) {
      setMiniLogout(false);
    }
  };
  
  const profileQuery = useQuery(["getProfile"], getExpertProfile);
  useEffect(() => {
    if (profileQuery?.data?.profile) {
      setExpertProfile(JSON.stringify(profileQuery?.data?.profile));
    }
    if (expertProfile) {
      localStorage.setItem("profile", expertProfile);
    }
  }, [profileQuery?.data?.profile, expertProfile]);
  const mutation = useMutation(logout, {
    onMutate: () => {
      setLogoutLogo(<LoadingOutlined />);
    },
    onSuccess: () => {
      navigate("/login");
      localStorage.clear("profile");
      window.location.reload();
    },
  });

  useEffect(() => {
    if (!localStorage.getItem("profile")) {
      navigate("/login");
    }
  });
  const profile = JSON.parse(localStorage.getItem("profile"));
  const name = profile?.firstName + " " + profile?.lastName;
  const img = process.env.REACT_APP_ARVAN_S3_BASE_URL + profile?.avatar;
  const location = useLocation();

  const menuHandler = () => {
    if (openMenu === "max-lg:hidden") {
      return setOpenMenu("max-lg:block"), setSize("100%");
    } else {
      setOpenMenu("max-lg:hidden");
      setSize("360");
    }
  };
  const closeMenu = () => {
    if (openMenu === "max-lg:hidden") {
      return setOpenMenu("max-lg:block");
    } else {
      setOpenMenu("max-lg:hidden");
    }
  };
  const [size, setSize] = useState("360");
  const [openMenu, setOpenMenu] = useState("max-lg:hidden");
  const navigate = useNavigate();
  const { Header, Content, Sider } = Layout;
  return (
    localStorage.getItem("profile") && (
      <ConfigProvider direction="rtl">
        <Layout>
          <Header
            style={{
              width: "100vw",
              height: "12vh",
              display: "flex",
              padding: "8px 16px",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#FFF",
              borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
            }}
          >
            <MenuOutlined
              onMouseDown={menuHandler}
              hidden={true}
              className=" text-[#015BC8] text-[35px] max-lg:block"
            />

            <a
              className="flex flex-row items-center gap-2 max-lg:justify-between"
              target="_blank"
              rel="noreferrer"
              href="https://agroiranexpert.com/"
            >
              <img
                className="max-lg:h-[50px] max-lg:w-[50px]"
                alt="expertLogo"
                src={expertLogo}
              />
              <label className=" font-body text-[#015BC8] text-[16px] font-[800] max-lg:hidden">
                شبکه جامع کارشناسان کشاورزی ایران
              </label>
            </a>

            <div className="flex flex-row items-center gap-3">
              <label className=" items-center flex flex-col gap-2 text-start  font-body text-[#000000]  max-lg:hidden">
                <p className="  leading-3 text-[16px] font-[500]">{name}</p>
                <div
                  onClick={() => mutation.mutate()}
                  className=" flex leading-3 items-center cursor-pointer text-right justify-start w-full hover:bg-red-200 px-2 rounded-xl flex-row text-red-600  gap-3 h-8 font-body"
                >
                  {logoutLogo}
                  <p>خروج از داشبورد</p>
                </div>
              </label>
              <div className=" bg-slate-200  outline outline-offset-1 outline-blue-500 rounded-[100%] w-[80px] max-lg:w-[50px] h-[80px] max-lg:h-[50px]  overflow-hidden">
                <img onClick={Logout} alt="doctor" src={img} />

                {miniLogout && (
                  <div
                    onMouseOutCapture={() => setMiniLogout(false)}
                    className="flex flex-col absolute gap-3 leading-3 border z-[10000] left-[6px] top-[75px] items-center rounded-xl p-3 font-body bg-white "
                  >
                    <p className="  leading-3 text-[14px] font-[500]">{name}</p>

                    <div
                      onClick={() => mutation.mutate()}
                      className="flex  flex-row items-center m-auto text-center cursor-pointer gap-3 text-red-500 "
                    >
                      <LogoutOutlined />
                      <p >خروج از داشبورد</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Header>

          <Layout hasSider>
            <Sider
              id="sider"
              className={openMenu}
              width={size}
              style={{
                overflow: "auto",
                height: "88vh",
                right: 0,
                bottom: 0,
              }}
            >
              <Menu
                selectedKeys={[location.pathname]}
                onClick={({ key }) => {
                  navigate(key);
                  closeMenu();
                }}
                mode="inline"
                defaultSelectedKeys={["1"]}
                style={{
                  margin: "auto",
                  height: "100%",
                }}
                items={[
                  {
                    style: {
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "5rem",
                      textAlign: "start",
                    },
                    label: "پیشخوان",
                    key: "/",
                    icon: <img alt="1" src={Pishkhan} />,
                  },
                  {
                    style: {
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "5rem",
                      textAlign: "start",
                    },
                    label: "خدمات گیرندگان",
                    key: "/farmers",
                    icon: <img alt="2" src={farmers} />,
                  },
                  {
                    style: {
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "5rem",
                      textAlign: "start",
                    },
                    label: "بازدید های من",
                    key: "/visits",
                    icon: <img alt="3" src={myReview} />,
                  },
                  {
                    style: {
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "5rem",
                      textAlign: "start",
                    },
                    label: "برنامه کودی های من",
                    key: "/nutrition-programs",
                    icon: <img alt="4" src={myPlans} />,
                  },
                  {
                    style: {
                      fontWeight: "500",
                      fontSize: "18px",
                      padding: "0 0.5rem",
                      textAlign: "start",
                      gap: "0.5rem",
                    },

                    label: "مدیریت صفحه",
                    key: "page",
                    height: "5rem",
                    icon: <img alt="5" src={personalPage} />,
                    children: [
                      {
                        label: "ویرایش صفحه شخصی",
                        key: "page-edit",
                        icon: <img alt="5" src={edit} />,
                        style: {
                          padding: "0 6rem 0 0",
                          textAlign: "start",
                          gap: "0.5rem",
                          fontSize: "1rem",
                        },
                      },
                      {
                        label: "مدیریت محتوا",
                        key: "content-management",
                        icon: <img alt="5" src={calender} />,
                        style: {
                          padding: "0 6rem 0 0",
                          textAlign: "start",
                          gap: "0.5rem",
                          fontSize: "1rem",
                        },
                      },
                      {
                        label: "مدیریت فروشگاه",
                        key: "shop-management",
                        icon: <img alt="5" src={shop} />,
                        style: {
                          padding: "0 6rem 0 0",
                          textAlign: "start",
                          gap: "0.5rem",
                          fontSize: "1rem",
                        },
                      },
                    ],
                  },
                ]}
                >
                </Menu>
                <div className="flex fixed  bottom-5 right-[1.5vw] max-lg:right-[6vw] items-center gap-4 ">
                <Button className="w-[150px]" href="mailto:agroyaar.ict@gmail.com" danger icon={<WarningOutlined/>} >گزارش خطا</Button>
                  <Button  className="w-[150px]" href={`https://agroiranexpert.com/${profile?.username}`} target="_blank" icon={<UserOutlined/>}>  صفحه شخصی</Button>
                </div>


            </Sider>
            <Content
              style={{
                textAlign: "center",
                marginLeft: "auto",
                marginRight: "auto",
                height: "88vh",
                overflow: "auto",
                backgroundColor: "#e7edf3",
              }}
            >
             
              <Pagination />
            </Content>
          </Layout>
        </Layout>
      </ConfigProvider>
    )
  );
}

function Pagination() {
  return (
    <div>
      <Routes>
        <Route path="" element={<Counter />}></Route>
        <Route path="farmers" element={<MyFarmers />} />

        <Route path="farmers/farmer-info" element={<SelectedFarmer />}></Route>
        <Route
          path="farmers/farmerId/show-all-nutrition-programs"
          index
          element={<AllPlans />}
        />
        <Route path="farmers/farmerId/show-all-visits" element={<AllVisit />} />
        <Route path="visits" element={<MyReviews />} />
        <Route path="nutrition-programs" element={<MyPlans />} />
        <Route path="page-edit" element={<PersonalPage />} />
        <Route path="content-management" element={<Content />} />
        <Route path="shop-management" element={<Shop/>}/>
        <Route path="content-management/article" element={<Article/>}/>
        <Route path="content-management/article/:id" element={<Article/>}/>
        <Route path="content-management/article/:id/comments" element={<Comments/>}/>
      </Routes>
    </div>
  );
}
export default DashboardLayout;
